/**
 * Announcement API สำหรับ user-classic — เรียก tenant-management announcements (target=user-classic)
 */
import { withApiBaseUrl } from '../lib/apiBaseUrl'

export type AnnouncementPriority = 'urgent' | 'general' | 'warning'

export interface Announcement {
  _id: string
  tenantId: string
  title: string
  content: string
  priority: AnnouncementPriority
  target: string[]
  requireAck: boolean
  imageUrl?: string | null
  displayDurationSeconds: number | null
  repeat?: {
    enabled: boolean
    intervalMinutes: number
    durationMinutes?: number
  }
  startDate: string
  endDate: string | null
  isActive: boolean
}

export const announcementService = {
  async getActive(tenantId: string, username?: string | null): Promise<{ success: boolean; data: Announcement[] }> {
    let path = `/api/v1/tenant-management/announcements/active?tenantId=${encodeURIComponent(tenantId)}&target=user-classic`
    if (username && username.trim()) path += `&username=${encodeURIComponent(username.trim())}`
    const url = withApiBaseUrl(path)
    const res = await fetch(url, {
      headers: { 'X-Tenant-ID': tenantId },
    })
    if (!res.ok) {
      if (import.meta.env.DEV) console.warn('[Announcements] getActive failed', res.status, res.statusText)
      return { success: false, data: [] }
    }
    const json = await res.json().catch(() => ({ success: false, data: [] }))
    return json as { success: boolean; data: Announcement[] }
  },

  async acknowledge(
    announcementId: string,
    tenantId: string,
    payload?: { userId?: string; sessionId?: string; clientFingerprint?: string }
  ): Promise<{ success: boolean }> {
    const path = `/api/v1/tenant-management/announcements/${announcementId}/ack`
    const url = withApiBaseUrl(path)
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Tenant-ID': tenantId },
      body: JSON.stringify({ tenantId, target: 'user-classic', ...payload }),
    })
    const json = await res.json()
    return json as { success: boolean }
  },
}
